enum LogLevel {
    All = 0,
    Debug = 1,
    Info = 2,
    Warning = 3,
    Error = 4,
    Critical = 5,
    Off = 6
}

enum localStorageKeys {
    orgId = "orgId",
    siteLocale = "siteLocale",
    defaultLanguageSelected = "defaultLanguageSelected",
    languageData = "languageData",
    username = "username",
    maskmobile = "maskmobile",
    userunmaskmobile = "userunmaskmobile",
    userid = "userid",
    agentId = "agentId",
    taskId = "taskId",
    userEmail = "userEmail",
    taskStatus = "taskStatus",
    InspectionStatus = "InspectionStatus",
    urlExpiryTime = "urlExpiryTime",
    AgentName = "AgentName",
    AgentMobile = "AgentMobile",
    flag = "flag",
    statusManagementFlag = "statusManagementFlag",
    OrgName = "OrgName",
    shortCode = "shortCode",
    themeDetail = "themeDetail",
    supportMobile = "supportMobile",
    supportEmail = "supportEmail",
    assetsBucket = "assetsBucket",
    Selfurl = "Selfurl",
    Originurl = "Originurl",
    hashKey = "hashKey",
    DeviceInfo = "DeviceInfo",
    deviceId = "deviceId",
    sessionID = "sessionID",
    authtoken = "authtoken",
    refreshToken = "refreshToken",
    isVerifedUser = "isVerifedUser",
    userType = "userType",
    profileTimezone = "profileTimezone",
    profileZoneOffset = "profileZoneOffset",
    tableval = "tableval",
    zoneMasterData = "zoneMasterData",
    orgMasterData = "orgMasterData",
    latitude = "latitude",
    longitude = "longitude",
    taskLat = "taskLat",
    taskLong = "taskLong",
    accuracy = "accuracy",
    isRunningAsyncUtility = "isRunningAsyncUtility",
    isRunningAsyncUtilityAddress = "isRunningAsyncUtilityAddress",
    taskChannel = "taskChannel",
    businessType = "businessType",
    documenttype = "documenttype",
    taskname = "taskname",
    channelConfignData = "channelConfignData",
    lang = "lang",
    isAddressVerificationEnable = "isAddressVerificationEnable",
    showTncPage = "showTncPage",
    showLocationPermissionPage = "showLocationPermissionPage",
    taskDetail = "taskDetail",
    isCustomCamera = "isCustomCamera",
    customCameraPromt = "customCameraPromt",
    isLocationAllowed = "isLocationAllowed",
    fetchCountyData = "fetchCountyData",
    showPropAddress = "showPropAddress",
    taskVerificationDetaail = "taskVerificationDetaail",
    addresshistory = "addresshistory",
    lastAddress = "lastAddress",
    addressMode = "addressMode"
}

export class AppEnum {
    public EntityOfLogLevel: typeof LogLevel = LogLevel;
    public EntityOfLocalStorageKeys: typeof localStorageKeys = localStorageKeys;
}